import { Dispatch } from 'redux';
import { axiosInstance, request, requestConfig } from './base';
import { UploadDocResponse } from 'store/modules/models/uploadDocResponse';
import {
  DebentureApiResponse,
  CadastroDebentureApiRequest,
  GETInstrumentosFilterParams,
  HistoricoResponse,
  SolicitarLiquidacaoRequest,
  DocumentRequest,
  CommandResultTyped,
} from 'common/genericTypes';
import { errorMessages } from 'common/errorMessages.strings';
import { AditamentoDiferenca, AditamentoRevisionData } from 'components/aditamentoModal/aditamentoRevisionModal';

export const GETDebentureDetalhes = async (
  dispatch: Dispatch,
  id: string,
  stackRequest: boolean = false
): Promise<DebentureApiResponse> => {
  return await request(
    () => axiosInstance.get<DebentureApiResponse>(`${requestConfig.api}api/v1/debentures/${id}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETDebentures = async (
  dispatch: Dispatch,
  params?: GETInstrumentosFilterParams,
  stackRequest: boolean = false
): Promise<Array<DebentureApiResponse>> => {
  return await request(
    () =>
      axiosInstance.get<Array<DebentureApiResponse>>(
        `${requestConfig.api}api/v1/debentures`,
        params ? { params } : undefined
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETDebentureByInstrumentoId = async (
  dispatch: Dispatch,
  id: string,
  stackRequest: boolean = false
): Promise<DebentureApiResponse> => {
  return await request(
    () => axiosInstance.get<DebentureApiResponse>(`${requestConfig.api}api/v1/debentures/instrumento-financeiro/${id}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTDebenture = async (
  dispatch: Dispatch,
  debenture: CadastroDebentureApiRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () => axiosInstance.post<DebentureApiResponse>(`${requestConfig.api}api/v1/debentures`, debenture),
    dispatch,
    errorMessages.instrumentoFinanceiro.generic,
    stackRequest
  );
};

export const PUTDebenture = async (
  dispatch: Dispatch,
  debentureId: string,
  debenture: CadastroDebentureApiRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () => axiosInstance.put<DebentureApiResponse>(`${requestConfig.api}api/v1/debentures/${debentureId}`, debenture),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PutEditarDebenture = async (
  dispatch: Dispatch,
  debentureId: string,
  debenture: CadastroDebentureApiRequest,
  justificativa: string,
  document?: File,
  stackRequest: boolean = false
) => {
  const fileForm = new FormData();

  if (document) fileForm.append('file', document);
  fileForm.append('justificativa', justificativa);

  const debentureStringfyed = JSON.stringify(debenture);
  fileForm.append('instrumentoFinanceiroRequest', debentureStringfyed);

  return await request(
    () =>
      axiosInstance.put<CommandResultTyped<string>>(`${requestConfig.api}api/v1/debentures/editar/${debentureId}`, fileForm, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};


export const PUTDebentureAditamento = async (
  dispatch: Dispatch,
  debentureId: string,
  debenture: CadastroDebentureApiRequest,
  date: string,
  document: File,
  stackRequest: boolean = false
) => {
  const fileForm = new FormData();
  fileForm.append('file', document);
  fileForm.append('dataAditamento', date);
  fileForm.append('aditamento', JSON.stringify(debenture));

  return await request(
    () =>
      axiosInstance.put<string>(`${requestConfig.api}api/v1/debentures/aditamento/${debentureId}`, fileForm, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTUploadDoc = async (
  dispatch: Dispatch,
  debentureId: string,
  emissionType: string,
  file: File,
  stackRequest: boolean = false
) => {
  const data = new FormData();
  data.append('file', file);
  return await request<Array<UploadDocResponse>>(
    () =>
      axiosInstance.put<Array<UploadDocResponse>>(
        `${requestConfig.api}api/v1/debentures/${debentureId}/document`,
        data,
        {
          params: {
            emissionType,
          },
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const DELETEUploadDoc = async (
  dispatch: Dispatch,
  debentureId: string,
  debentureDocumentId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () => axiosInstance.delete(`${requestConfig.api}api/v1/debentures/${debentureId}/document/${debentureDocumentId}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTInterOpDebenture = async (
  dispatch: Dispatch,
  debenture: CadastroDebentureApiRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<DebentureApiResponse>(`${requestConfig.api}api/v1/debentures/transferencia-dvm`, debenture),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTEnviarLiquidacao = async (
  dispatch: Dispatch,
  debentureId: string,
  debentureSolicitarLiquidacaoRequest: SolicitarLiquidacaoRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<DebentureApiResponse>(
        `${requestConfig.api}api/v1/debentures/${debentureId}/enviar-liquidacao`,
        debentureSolicitarLiquidacaoRequest
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTConfirmarLiquidacaoDebenture = async (
  dispatch: Dispatch,
  debentureId: string,
  precoUnitarioLiquidacao: number,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<DebentureApiResponse>(
        `${requestConfig.api}api/v1/debentures/${debentureId}/confirmar-liquidacao`,
        { precoUnitario: precoUnitarioLiquidacao },
        { headers: { 'Content-Type': 'application/json' } }

      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETHistoricoDebenture = async (dispatch: Dispatch, debentureId: string, stackRequest: boolean = false) => {
  return await request(
    () =>
      axiosInstance.get<Array<HistoricoResponse>>(
        `${requestConfig.api}api/v1/debentures/${debentureId}/historico-de-alteracoes`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETAditamentoDebenture = async (dispatch: Dispatch, aditamentoId: string, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.get<AditamentoRevisionData>(`${requestConfig.api}api/v1/debentures/aditamento/${aditamentoId}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTAditamentoDebenture = async (dispatch: Dispatch, aditamentoId: string, diferenca: AditamentoDiferenca[], stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.put<Array<AditamentoDiferenca>>(`${requestConfig.api}api/v1/debentures/aditamento/atualizar/${aditamentoId}`, diferenca),
    dispatch,
    undefined,
    stackRequest
  );
};